module.exports = __webpack_public_path__ + "img/DAVID_CANNON_28-rs.86f20828.jpg";